import ErrorWrapper from './error-wrapper';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';

export default function ExpiredPage() {
  return (
    // FIXME: get logged in user email from session if possible
    <ErrorWrapper>
      <Card variant="outlined" sx={{ maxWidth: 920, zIndex: 2, px: 4, py: 6 }}>
        <CardHeader
          title={'Subscription Expired'}
          subheader="Your gPanel subscription has expired. You should have received an email from our Renewals team. You are currently logged in as {{USER_EMAIL}}. If you have any questions, please contact our Renewal Support Team at renewalsupport@promevo.com."
        />
      </Card>
    </ErrorWrapper>
  );
}
